import BaseError from '@/objects/Exceptions/BaseError'

export default class HttpUnAuthenticatedError extends BaseError {
  constructor(message) {
    super(message) // (1)
    this.name = "HttpUnAuthenticatedError" // (2)
  }
}
